import { useState } from "react";
import persian from "react-date-object/calendars/persian";
import { DateObject } from "react-multi-date-picker";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import { useNavigate } from "react-router-dom";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import Button from "../../../common/button/Button";
import FieldDescription from "../../add/form/FieldDescription";
import FieldImage from "../../add/form/FieldImage";
import FieldPrice from "../../add/form/FieldPrice";
import FieldStart from "../../add/form/FieldStart";
import FieldTitle from "../../add/form/FieldTitle";
import FieldOwner from "./FieldOwner";
import DoctorMultiSelect from "../../../../components/DoctorMultiSelect";

export default function Form() {
	const navigate = useNavigate();
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [price, setPrice] = useState("");
	const [image, setImage] = useState(null);
	const [startDatetime, setStartDatetime] = useState(new DateObject({ calendar: persian }));
	const [ownerProfileId, setOwnerProfileId] = useState("");
	const [instructorIds, setInstructorIds] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const handleSubmit = () => {
		if (isLoading) return;
		if (!ownerProfileId) {
			setErrorMessage('انتخاب درمانگر الزامی است');
			return;
		}
		setIsLoading(true);
		api.webinarAdd({
			token: LoginHelper.getToken(),
			owner_profile_id: ownerProfileId,
			instructor_ids: JSON.stringify(instructorIds),
			title: title,
			description: description,
			price: price,
			image_file: image,
			start_datetime: startDatetime.toDate().toISOString(),
		}).then((res) => {
			setIsLoading(false);
			const webinarId = res.id;
			navigate('/webinar_detail/' + webinarId + '/');
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}

	return (
		<div className="flex flex-col gap-4 bg-white rounded-[10px] p-4">
			<div className="text-center font-Vazir-600">
				ساخت وبینار مدیریت
			</div>
			<div className="spacer p-[1px]"></div>
			<FieldOwner
				ownerProfileId={ownerProfileId}
				onChange={setOwnerProfileId}
			/>
			<DoctorMultiSelect value={instructorIds} onChange={setInstructorIds} />
			<div className="spacer p-[1px]"></div>
			<FieldTitle
				title={title}
				onChange={(e) => setTitle(e.target.value)}
			/>
			<div className="spacer p-[1px]"></div>
			<FieldDescription
				description={description}
				onChange={(e) => setDescription(e.target.value)}
			/>
			<div className="spacer p-[1px]"></div>
			<FieldPrice
				price={price}
				onChange={(e) => setPrice(e.target.value)}
			/>
			<div className="spacer p-[1px]"></div>
			<FieldImage
				image={image}
				onChange={(e) => setImage(e.target.files[0])}
			/>
			<div className="spacer p-[1px]"></div>
			<FieldStart
				startDatetime={startDatetime}
				onChange={setStartDatetime}
			/>
			<div className="spacer p-[1px]"></div>
			<div className="flex flex-row justify-end">
				<div className="min-w-[100px] min-h-[40px]">
					<Button
						onClick={() => { handleSubmit() }}
						label={"ارسال"}
						isLoading={isLoading}
					/>
				</div>
			</div>
			{errorMessage && (
				<div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
			)}
		</div>
	)
}
